import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IPayment } from '@/modules/payment/types';
import { Typography } from '@/shared/components/atoms';

import CheckMark from '~/images/shared/CheckMarkWithoutBG.svg';
import Close from '~/images/shared/CloseWithoutBG.svg';

const PlanDetailsCard: React.FC<
  IPayment.IBundleDetailsSchema & { isLast: boolean; isLastIdx: boolean }
> = ({ bundles, description, title, isLast, isLastIdx }) => {
  const { t } = useTranslation('payment');

  return (
    <div
      className={clsx(
        'flex w-full',
        !isLast && !isLastIdx && 'border-b-xs border-background-200'
      )}
    >
      <div className='w-1/4 py-16 px-24'>
        <Typography
          variant='body1'
          className='text-text-default'
          weight='semiBold'
        >
          {t(title)}
        </Typography>
        <Typography variant='caption' className='text-surface-10'>
          {t(description)}
        </Typography>
      </div>
      <div className='flex w-3/4'>
        {bundles.map((item, idx) => (
          <div
            key={idx}
            className={clsx(
              ' flex w-1/3 flex-col items-center justify-center p-16 text-24',
              idx === 1
                ? 'bg-primary-60 text-white'
                : 'bg-background-neutral-99 text-primary-default',
              isLast && isLastIdx && 'rounded-b-2xl'
            )}
          >
            {item.available !== undefined && (
              <span>{item.available ? <CheckMark /> : <Close />}</span>
            )}
            {item.description && (
              <span
                className={clsx(
                  'text-14',
                  idx === 1 ? 'text-white' : 'text-text-default'
                )}
              >
                {t(item.description)}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export { PlanDetailsCard };
